import { render, staticRenderFns } from "./PerformanceReportSectionForm.vue?vue&type=template&id=67b664fb&scoped=true"
import script from "./PerformanceReportSectionForm.vue?vue&type=script&lang=js"
export * from "./PerformanceReportSectionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b664fb",
  null
  
)

export default component.exports